import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import SubmitResultPanel from '../common/SubmitResultPanel'
import SubmissionError from '../common/SubmitResultPanel/SubmissionError'
import SubmissionSuccess from '../common/SubmitResultPanel/SubmissionSuccess'
import { STEP_KEYS } from './constants'

const propTypes = {
  /**
   * Error message if submission failed
   */
  errorResetingPassword: PropTypes.string,
}

function SubmitPanel(props) {
  const { errorResetingPassword = null } = props ?? {}

  return (
    <SubmitResultPanel
      hasSubmissionError={!!errorResetingPassword}
      successContent={<SubmissionSuccess message={<FormattedMessage id="ENGAGE.RESET_PASSWORD_SUCCESS" />} />}
      errorContent={
        <SubmissionError
          message={<FormattedMessage id="ENGAGE.RESET_PASSWORD_FAIL" />}
          errors={errorResetingPassword}
        />
      }
      backStepKey={STEP_KEYS.RESET_PASSWORD}
    />
  )
}

SubmitPanel.propTypes = propTypes

export default SubmitPanel
